var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow overflow-hidden max-w-3xl mx-auto my-12  sm:rounded-lg"
    },
    [
      !_vm.isLoading && _vm.checkout
        ? _c("div", [
            _c(
              "div",
              { staticClass: "px-4 py-5 border-b border-gray-200 sm:px-6" },
              [
                _c(
                  "h3",
                  {
                    staticClass:
                      "text-lg leading-6 font-medium text-gray-900 flex justify-between"
                  },
                  [
                    _vm._v(" Order details "),
                    _c("SendMessageDropdown", {
                      attrs: { checkout: _vm.checkout }
                    })
                  ],
                  1
                )
              ]
            ),
            _c("div", { staticClass: "px-4 py-5 sm:p-0" }, [
              _c("dl", [
                _c(
                  "div",
                  {
                    staticClass:
                      "sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Customer ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.checkout.customer.firstName) +
                            " " +
                            _vm._s(_vm.checkout.customer.lastName) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Date ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFilter")(_vm.checkout.createdAt)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Recovery status ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "px-2 inline-flex text-xs leading-5 font-semibold rounded-full ",
                            class: {
                              "bg-red-100 text-red-800": !_vm.checkout
                                .isRecovered,
                              "bg-green-100 text-green-800":
                                _vm.checkout.isRecovered
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.checkout.isRecovered
                                    ? "recovered"
                                    : "Not recovered"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Message status ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "px-2 inline-flex text-xs leading-5 font-semibold rounded-full ",
                            class: {
                              "bg-red-100 text-red-800": !_vm.checkout
                                .isMessageSent,
                              "bg-green-100 text-green-800":
                                _vm.checkout.isMessageSent
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.checkout.isMessageSent
                                    ? "Sent"
                                    : "Not sent"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Checkout id ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [_vm._v(" " + _vm._s(_vm.checkout.checkoutId) + " ")]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                  },
                  [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500"
                      },
                      [_vm._v(" Total amount ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.checkout.currency) +
                            " " +
                            _vm._s(_vm.checkout.totalPrice) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "text-center" }, [_vm._v("Loading...")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }